import React, {useCallback} from 'react';
import styled from 'styled-components';
import {RemoveIcon} from '../../icons';
import {useActiveCreator} from '../creatorfeed.hooks';
import {stopFocusOnClick} from 'epic-ue-shared';
import {AccentColorProps, AccentColorOptions} from 'epic-ue-theme';

const CloseWrap = styled.div<{accentColor?: AccentColorOptions}>`
    a {
        position: relative;
        z-index: 3;
        right: 40px;
        float: right;
        cursor: pointer;
        font-size: 40px;
        line-height: 32px;
        transition: color 0.25s ${(p) => p.theme.easing}, opacity 0.25s ${(p) => p.theme.easing},
            transform 0.25s ${(p) => p.theme.easing};

        ${(p) => p.theme.breakpoints.down('sm')} {
            right: 16px;
            top: 16px;
        }

        ${(p) => p.theme.breakpoints.up('md')} {
            top: 35px;
        }

        &:active {
            opacity: 0.5;
            transform: scale(0.8);
        }

        &:hover {
            color: ${(p) =>
                p.accentColor
                    ? p.theme.palette.accent[p.accentColor]
                    : p.theme.palette.text.primary};
        }
    }
`;

export const CreatorFeedDetailCloseBtn = ({accentColor}: AccentColorProps): JSX.Element => {
    const {setActiveCreator} = useActiveCreator();
    const close = useCallback(
        (e) => {
            e.preventDefault();
            setActiveCreator('');
        },
        [setActiveCreator]
    );

    return (
        <CloseWrap accentColor={accentColor}>
            <a role="menuitem" tabIndex={0} onClick={close} onMouseDown={stopFocusOnClick}>
                <RemoveIcon fontSize="inherit" />
            </a>
        </CloseWrap>
    );
};
